import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Input, Form, Upload, message, Row, Col, Carousel } from "antd";
// import { ReactComponent as Banner1 } from "../../../src/assets/images/company-01.svg";
// import { ReactComponent as BannerWork } from "../../../src/assets/images/company-01.svg";
import Banner1  from "../../../src/assets/images/company-01.svg";
import BannerWork  from "../../../src/assets/images/work-01.svg";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { Footer } from "../footer";
import { Header } from "../header";
import "./home.css"
import { baseUrl } from "../../../src/config"
import TextArea from "antd/es/input/TextArea";
// import Image1 from "../../../src/assets/images/image1.svg"
// import Image2 from "../../../src/assets/images/image2.svg";
// import Image3 from "../../../src/assets/images/image3.svg";
import Image1 from "../../../src/assets/images/slider1.svg"
import Image2 from "../../../src/assets/images/slider2.svg";
import Image3 from "../../../src/assets/images/slider4.svg";
import Image4 from "../../../src/assets/images/slider3.svg";
import mImage1 from "../../../src/assets/images/mSlider1.svg"
import mImage2 from "../../../src/assets/images/mSlider2.svg";
import mImage3 from "../../../src/assets/images/4.svg";
import mImage4 from "../../../src/assets/images/3.svg";
import Underline from "../../../src/assets/images/underline.svg";
import UpAnimation from "../../../src/components/UpAnimation";
import LeftRightAnimation from "../../../src/components/LeftRightAnimation";
import InlineCounter from "../../components/InlineCounter";
import { useNavigate } from "react-router-dom";
export const Home = () => {
  const [reviews, setReviews] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const contactRef = useRef(null)
  const [carouselImages, setCarouselImages] = useState([]);

  const navigate=useNavigate()
  const [reviewReq, setReviewReq] = useState({
    name: "",
    companyName: "",
    review: "",
    profile: "",
  });
  const [inputReq, setInputReq] = useState({
    name: "",
    mobile: "",
    email: "",
    subject: "", description: ""
  })
   const headerRef:any=useRef();

    useEffect(()=>{
          if(window.innerWidth<1000){
      setCarouselImages([mImage1,mImage2,mImage3,mImage4])
    }else {
      setCarouselImages([Image1, Image2, Image3, Image4])
    }
    getReviews(); // Call getReviews when component mounts
      document.addEventListener('DOMContentLoaded', () => {
  const img = document.querySelector('.image');

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        img.classList.add('reveal');
        observer.unobserve(entry.target); // stop observing after animation
      }
    },
    {
      threshold: 0.3, // adjust as needed
    }
  );

  const imageContainer = document.querySelector('#imageSection');
  observer.observe(imageContainer);
});

        headerRef?.current?.scrollIntoView({ behavior: 'smooth' });
    },[])



  const handlePreview = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      const image: any = new Image();
      image.src = reader.result;
      document.body.append(image);
    };
    reader.readAsDataURL(file.originFileObj); // Read the file as data URL
  };

  const getReviews = async () => {
    try {
      const resp = await axios.get(`${baseUrl}reviews`); // Assuming your API endpoint is 'reviews'
      console.log(resp.data); // Log the response to check
      setReviews(resp.data);
    } catch (e) {
      console.error(e);
    }
  };

  const [form] = Form.useForm();

  // Handle modal visibility
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setFileList([])
    form.resetFields();
    setIsModalVisible(false);
  };

 
  const handleSubmit = async () => {
    // Check if all fields in formData are filled
    const allFieldsFilled = Object.values(inputReq).every(value => {
      // Only trim if the value is a string
      return typeof value === 'string' ? value.trim() !== "" : value !== undefined && value !== null;
    });

    if (allFieldsFilled) {
      // If all fields are filled, log the form data and close the modal
      try {
        const resp = await axios.post(
          `${baseUrl}enquiry/add`, inputReq
        );
        if (resp?.data) {
          setInputReq({
            name: "",
            mobile: "",
            email: "",
            subject: "", description: ""
          })
          message.success("Team will get back to you soon")
        }
      } catch (e) {
        console.error(e);
      }

    } else {
      // If any field is empty, show a warning message
      message.error("Please fill in all fields before submitting.");
    }
  };
  const handlePostReview = async (values) => {
    // Handle posting the review (e.g., send to an API)
    try {
      const resp = await axios.post(`${baseUrl}review/create`, { ...reviewReq }); // Assuming your API endpoint is 'reviews'
      message.success("Review posted successfully!");
      form.resetFields();
      getReviews();
      setFileList([])
    } catch (e) {
      console.error(e);
    }
    setIsModalVisible(false);
  };

  const handleFileChange = ({ fileList }) => {
    console.log("File uploaded: ", fileList);
    setFileList(fileList);
    if (fileList && fileList.length > 0) {
      const file = fileList[0].originFileObj;
      const reader = new FileReader();
      reader.onloadend = () => {
        setReviewReq({
          ...reviewReq,
          profile: reader.result as string, // Set the profile picture as Base64 string
        });
      };
      reader.readAsDataURL(file); // Convert the image to Base64
    }
    
  };

 return (
    <div
      className="home-container" ref={headerRef}
    >
      <Header />
      <div style={{ width: "100%", background:"#000",display:"flex",alignItems:"center",justifyContent:"center"}}>
        <div style={{ width: "100%", position: "relative" ,height:"100vh",display:"flex",flexDirection:"column",justifyContent:"flex-end",flex:1}} >
          {carouselImages?.length > 0 && <Carousel autoplay autoplaySpeed={2000}>
            {carouselImages?.map((i, index) => (
              <div key={index} style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "20px", background: "red" }}>
                <div style={{ fontSize: 18, width: "65%", height: "70vh", background: "#000", overflow: "hidden" }}>
                  {i && <img style={{ width: "100%", height: "100%", objectFit: "contain" }} src={i}></img>}
                </div>
              </div>
            ))}
          </Carousel>}
          <div style={{width:"100%"}}>
            <Button
            style={{ marginTop: 50,textAlign:"center"}}
            className="home-header-button"
            onClick={() => {

              contactRef?.current?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            KNOW MORE
          </Button>
          </div>

        </div>
      </div>
      <div className="quotes-section">
        <div className="quotes-section-title">
    THY one stop for <span style={{ color: "#f7941d" }}>design and print</span>
  </div>

  <svg
    className="animated-underline"
    width="150"
    height="20"
    viewBox="0 0 150 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="gradientStroke" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#f6922f" />
        <stop offset="100%" stopColor="#e04c08" />
      </linearGradient>

      <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    <path
      className="underline-path"
      d="M5 15 Q75 5 145 15"
      fill="none"
      stroke="url(#gradientStroke)"
      strokeWidth="4"
      strokeLinecap="round"
      filter="url(#glow)"
    />
  </svg>

       
        <div
          className="quotes-container"
        >
          <div className="quotes-left-content">
           <LeftRightAnimation> 
            <div className="subtitle">
            Leading design and print company delivering{" "}
              <span style={{ color: "#f7941d" }}>excellence with every project</span>
            </div>
            </LeftRightAnimation> 
            <div className="text">
            THY is a leading design and print company, renowned for creativity and excellence. Our team
works closely with clients to craft tailored solutions, whether it’s for marketing materials,
branding, or custom prints. Trust us for innovative designs and flawless prints, all under one
roof.
            </div>
            <div style={{ marginTop: 20 }}>
              <Button
                className="btn-why-thy"
                onClick={()=>navigate("/why_thy")}
              >
                WHY THY?
              </Button>
            </div>
          </div>
          <div style={{width:"100%"}} >

           <img style={{width:"100%"}} src={Banner1} className="image"></img>
          </div>
        </div>
      </div>
      <div className="work-section">
        <div className="work-header">Designing brilliance. Printing perfection. <span style={{ color: "#f7941d" }}>That’s our craft</span>
        </div>
        <svg
    className="animated-underline"
    width="150"
    height="20"
    viewBox="0 0 150 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="gradientStroke" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#f6922f" />
        <stop offset="100%" stopColor="#e04c08" />
      </linearGradient>

      <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    <path
      className="underline-path"
      d="M5 15 Q75 5 145 15"
      fill="none"
      stroke="url(#gradientStroke)"
      strokeWidth="4"
      strokeLinecap="round"
      filter="url(#glow)"
    />
  </svg>
        <div className="work-body">
          <div style={{width:"100%"}}>
            <img style={{width:"100%"}} src={BannerWork}></img>
          </div>
          <div className="work-content">
            <LeftRightAnimation>
            <div className="work-title">
            THY designs and prints with precision, creativity, and <span className="highlight-text">exceptional quality every times</span>
            </div>
            </LeftRightAnimation>
            <div className="work-description">
            THY offers a complete suite of design and printing services. We’re dedicated to delivering
visually striking designs paired with flawless printing. From concept to final print, we focus on
quality, creativity, and precision to ensure your project exceeds expectations, helping you make
a lasting impression.
            </div>
            <div className="work=button">
              <Button className="why-thy-button"  onClick={()=>navigate("/services")}>EXPLORE OUR SERVICES</Button>
            </div>
          </div>

        </div>
      </div>
      <div className="image-section">
        <UpAnimation>
        <div className="image-section-title">At THY, we don’t just promise quality—<span style={{ color: "#f7941d" }}>we deliver it :</span></div>
        </UpAnimation>
        <div className="image-section-div">
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "50%" : "100%" }}>
            <div style={{fontSize:24,fontWeight:500,marginBottom:10,color:"#f7941d"}}>Industry Leader</div>
            <div style={{fontSize:16,fontWeight:"300"}}>From humble beginnings to industry leader, THY has built innovative design and printing
solutions. With 15 years of experience, we provide high-quality, tailored design and printing
services to meet the diverse needs of all.</div>
          </div>
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "25%" : "100%" }}>
            <div style={{fontSize:24,fontWeight:500,color:"#f7941d"}}>Creative at scale</div>
            <div style={{fontSize:30,fontWeight:500,color:"#FFF"}}>
               <InlineCounter target={3} suffix="x" />
            </div>
            <div style={{fontSize:16,fontWeight:"300",color:"#b6b2b2ff"}}>Faster delivery of designs</div>
          </div>
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "25%" : "100%" }}>
            <div style={{fontSize:24,fontWeight:500,color:"#f7941d"}}>Years of Excellence</div>
            <div style={{fontSize:30,fontWeight:500,color:"#FFF"}}>
              <InlineCounter target={15} suffix="+" />
            </div>
            <div style={{fontSize:16,fontWeight:"300",color:"#b6b2b2ff"}}>Proven Success</div>
          </div>
        </div>
        <div className="image-section-div">
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "25%" : "100%" }}>
          <div style={{fontSize:24,fontWeight:500,color:"#f7941d"}}>Project Milestones</div>
            <div style={{fontSize:30,fontWeight:500,color:"#FFF"}}> <InlineCounter target={2035} suffix="+" /></div>
            <div style={{fontSize:16,fontWeight:"300",color:"#b6b2b2ff"}}>On Time, Every Time</div>
          </div>
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "25%" : "100%" }}>
          <div style={{fontSize:24,fontWeight:500,color:"#f7941d"}}>Client Support</div>
            <div style={{fontSize:30,fontWeight:500,color:"#FFF"}}><InlineCounter target={100} suffix="%" /></div>
            <div style={{fontSize:16,fontWeight:"300",color:"#b6b2b2ff"}}>Instant Response</div>
          </div>
          <div className="image-item" style={{ width: window.innerWidth > 1000 ? "50%" : "100%" }}>
            <div style={{fontSize:24,fontWeight:500,marginBottom:10,color:"#f7941d"}}>Passion Meets Delivery</div>
            <div style={{fontSize:16,fontWeight:"300"}}>We’ve completed 2035+ projects, delivering solutions with quality, creativity, and care. Our commitment to excellence ensures each project leaves a lasting impact, building trust, satisfaction, and meaningful connections.</div>
          </div>

        </div>
      </div>
      <div className="contact-title">Ask to our <span style={{ color: "#f7941d" }}>Expert!</span></div>
      <svg
    className="animated-underline"
    width="150"
    height="20"
    viewBox="0 0 150 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="gradientStroke" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#f6922f" />
        <stop offset="100%" stopColor="#e04c08" />
      </linearGradient>

      <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    <path
      className="underline-path"
      d="M5 15 Q75 5 145 15"
      fill="none"
      stroke="url(#gradientStroke)"
      strokeWidth="4"
      strokeLinecap="round"
      filter="url(#glow)"
    />
  </svg>
      <div className="contact-form" ref={contactRef} style={{  width: window.innerWidth < 1000 ? "80%" : 500 }}>
        <div style={{ fontSize: 28 }}>Contact Us</div>
        <div className="contact-group">
          <div>Name</div>
          <div><Input value={inputReq.name} onChange={(e) => setInputReq({ ...inputReq, name: e.target.value })}></Input></div>
        </div>
        <div className="contact-group">
          <div>Phone</div>
          <div><Input value={inputReq.mobile} onChange={(e) => setInputReq({ ...inputReq, mobile: e.target.value })}></Input></div>
        </div>
        <div className="contact-group">
          <div>Email</div>
          <div><Input value={inputReq.email} onChange={(e) => setInputReq({ ...inputReq, email: e.target.value })}></Input ></div>
        </div>
        <div className="contact-group">
          <div>Subject</div>
          <div><Input value={inputReq.subject} onChange={(e) => setInputReq({ ...inputReq, subject: e.target.value })}></Input></div>
        </div>
        <div className="contact-group">
          <div >Description</div>
          <div><TextArea value={inputReq.description} style={{ width: "183px" }} onChange={(e) => setInputReq({ ...inputReq, description: e.target.value })}></TextArea></div>
        </div>
        <Button style={{ width: "80%", background: "#f7941d", borderRadius: 12, border: "1px solid #f7941d", color: "#fff", fontWeight: 600, fontSize: 20 }}
          onClick={handleSubmit}>Submit</Button>
      </div>
      {/* brousel Section with Reviews */}
      <div className="carousel-section">
        <UpAnimation>
        <div className="carousel-section-title">What Our <span style={{ color: "#f7941d" }}>Client Says!</span> </div>
        </UpAnimation>
        {reviews?.length > 0 && <Carousel  arrows autoplay autoplaySpeed={2000}>
          {reviews?.map((r, index) => (
            <div key={index} style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "10px", background: "red" }}>
              <div style={{ backgroundColor: "#262626", padding: "20px", color: "#FFF", display: "flex", justifyContent: "center",width:"80%" }}>
                <div style={{ fontSize: 18, width: 170, height: 170, borderRadius: 100, background: "#fff", overflow: "hidden" }}>
                  {r?.profile && <img style={{ width: "100%", height: "100%" }} src={r?.profile}></img>}
                </div>
              </div>
              <div style={{ backgroundColor: "#262626",  color: "#FFF" ,width:"80%",padding: "0px 20px 20px 20px"}}>
                <div style={{ fontSize: 24,fontWeight:"bold" }}>{r?.name}</div>
                <div style={{ fontSize: 20, color: "#FFD700"}}>★★★★★</div>
              </div>
              <div style={{ backgroundColor: "#262626", padding: "0px 20px 20px 20px", color: "#FFF" ,marginBottom:20,width:"80%"}}>
                <div
  style={{
    fontSize: 18,
    fontStyle: "italic",
    color: "#ffffff",
  }}
>
  {r?.review}
</div>
              </div>

            </div>
          ))}
        </Carousel>}

        <Button
          onClick={showModal}
          style={{
            height: 40,
            color: "#151515",
            fontSize: 28,
            background: "#f7941d",
            border: "none",
            marginTop: 60,
            fontWeight: 600,
          }}
        >
          Give Your Review
        </Button>
      </div>
      <Footer />
      {/* Modal to Post Review */}
      <Modal
        title={<span style={{ fontSize: "24px", fontWeight: "bold" }}>Post a Review</span>}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={600}
        maskClosable={false}
        style={{ border: "2px solid #f7941d", height: 460, borderRadius: 8 }}
        bodyStyle={{ fontSize: "16px" }}
      >
        <Form form={form} onFinish={handlePostReview} layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label={<span style={{ fontWeight: "bold", fontSize: "18px" }}>Name</span>}
                rules={[{ required: true, message: "Please input your name!" }]}
              >
                <Input placeholder="Enter your name" value={reviewReq?.name} onChange={(e) => setReviewReq({ ...reviewReq, name: e.target.value })} />
              </Form.Item>
            </Col>

            {/* Company Name and Input Field */}
            <Col span={12}>
              <Form.Item
                name="company"
                label={<span style={{ fontWeight: "bold", fontSize: "18px" }}>Company Name</span>}
                rules={[{ required: true, message: "Please input your company name!" }]}
              >
                <Input placeholder="Enter your company name" onChange={(e) => setReviewReq({ ...reviewReq, companyName: e.target.value })} />
              </Form.Item>
            </Col>
          </Row>

          {/* Review Field */}
          <Form.Item
            name="review"
            label={<span style={{ fontWeight: "bold", fontSize: "18px" }}>Review</span>}
            rules={[{ required: true, message: "Please write a review!" }]}
          >
            <Input.TextArea
              placeholder="Write your review here"
              rows={4}
              onChange={(e) => setReviewReq({ ...reviewReq, review: e.target.value })}
            />
          </Form.Item>

          {/* Profile Picture Upload */}
          <Form.Item
            name="profile"
            // value={reviewReq?.profile}
            label={<span style={{ fontWeight: "bold", fontSize: "18px" }}>Profile Picture</span>}
            valuePropName="fileList"
            getValueFromEvent={(e) => e && e.fileList}
          >
            <Upload
              accept="image/*"
              showUploadList={false}
              beforeUpload={() => false} // Disable automatic upload
              onChange={handleFileChange}
              onPreview={handlePreview}
              maxCount={1} // Limit to 1 file
            >
              <Button icon={<UploadOutlined />}>Upload Profile Picture</Button>
            </Upload>

            {fileList.length > 0 && (
              //   <div style={{ marginTop: 16, display: "flex", alignItems: "center" }}>
              <img
                src={URL.createObjectURL(fileList[0].originFileObj)} // Create URL for the uploaded image
                alt="Profile Preview"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginLeft: "10px"
                }}
              />
              //   </div>
            )}
          </Form.Item>

          {/* Footer with Cancel and Post Review buttons */}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, fontWeight: 600 }}>
            <Button onClick={handleCancel} style={{ borderRadius: 12 }}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ background: "#f7941d", color: "#151515", borderRadius: 12 }}
            >
              Post Review
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};
